import { createContext, useContext } from "react";
import { NotificationMode } from "@/domains/app";

export interface AppConfigContextType {
  notificationMode: NotificationMode;
  setNotificationMode: (notificationMode: NotificationMode) => void;
}

export const AppConfigContext = createContext<AppConfigContextType>(null!);

export const useAppConfig = () => useContext(AppConfigContext);
